function createSpinner() {
    const spinner = document.createElement('span');
    spinner.className = 'spinner-border spinner-border-sm me-2 align-middle payment-submit-spinner';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-hidden', 'true');
    return spinner;
}
export function createSubmitButtonBusyState(scope) {
    let tracked = null;
    return {
        begin() {
            if (tracked !== null || !scope) {
                return;
            }
            const controls = Array.from(scope.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]'));
            tracked = controls.map((control) => {
                const spinner = control instanceof HTMLInputElement ? null : createSpinner();
                if (spinner) {
                    control.insertAdjacentElement('afterbegin', spinner);
                }
                const entry = { control, spinner, disabledHere: !control.disabled };
                control.disabled = true;
                control.setAttribute('aria-busy', 'true');
                return entry;
            });
        },
        end() {
            if (tracked === null) {
                return;
            }
            tracked.forEach(({ control, spinner, disabledHere }) => {
                spinner?.remove();
                if (disabledHere) {
                    control.disabled = false;
                }
                control.removeAttribute('aria-busy');
            });
            tracked = null;
        },
    };
}
